import React from "react";
import qs from "qs";
import pointPNG from "./point.png";

function detectVersion() {
  let isAndroid,
    isIOS,
    isIOS9,
    version,
    u = navigator.userAgent,
    ua = u.toLowerCase();

  if (u.indexOf("Android") > -1 || u.indexOf("Linux") > -1) {
    //android终端或者uc浏览器
    //Android系统
    isAndroid = true;
  }

  if (ua.indexOf("like mac os x") > 0) {
    //ios
    var regStr_saf = /os [\d._]*/gi;
    var verinfo = ua.match(regStr_saf);
    version = (verinfo + "").replace(/[^0-9|_.]/gi, "").replace(/_/gi, ".");
  }
  var version_str = version + "";
  if (version_str != "undefined" && version_str.length > 0) {
    version = parseInt(version);
    if (version >= 8) {
      // ios9以上
      isIOS9 = true;
    } else {
      isIOS = true;
    }
  }
  return { isAndroid, isIOS, isIOS9 };
}

// 判断手机上是否安装了app，如果安装直接打开url，如果没安装，执行callback
function _openApp(url, callback) {
  let { isAndroid, isIOS, isIOS9 } = detectVersion();
  if (isAndroid || isIOS) {
    var timeout,
      t = 4000,
      hasApp = true;
    var openScript = setTimeout(function() {
      if (!hasApp) {
        callback && callback();
      }
      document.body.removeChild(ifr);
    }, 5000);

    var t1 = Date.now();
    var ifr = document.createElement("iframe");
    ifr.setAttribute("src", url);
    ifr.setAttribute("style", "display:none");
    document.body.appendChild(ifr);

    timeout = setTimeout(function() {
      var t2 = Date.now();
      if (t2 - t1 < t + 100) {
        hasApp = false;
      }
    }, t);
  }

  if (isIOS9) {
    window.location.href = url;
    setTimeout(function() {
      callback && callback();
    }, 250);
    setTimeout(function() {
      window.location.reload();
    }, 1000);
  }
}

//跳h5
function goConfirmAddr() {
  window.location.href = "http://m.gaotu100.com";
}
// window.onload = function() {
//   openApp("superclass://home", goConfirmAddr);
// };

/******** */
function is_weixn() {
  let ua = navigator.userAgent.toLowerCase();
  if (ua.indexOf("micromessenger") > -1) {
    return true;
  } else {
    return false;
  }
}
const IS_WX = is_weixn();

var u = navigator.userAgent;
var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端
var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

function openApp() {
  let isBlur = false;
  const search = document.location.search;
  const querystring = search.substring(1);
  const { url } = qs.parse(querystring);
  let timeout = 2000;
  if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
    window.location.href = url; //ios app协议
    setTimeout(() => {
      // alert("isBlur--" + isBlur);
      // alert(document.hidden);
      if (document.visibilityState !== "hidden") {
        window.location.href =
          "https://apps.apple.com/cn/app/%E8%8F%B2%E5%B0%BC%E8%90%A8%E6%B1%82%E8%81%8C%E9%80%9A/id1500104460"; //Ios下载地址
      }
    }, timeout);
  } else if (navigator.userAgent.match(/android/i)) {
    var startTime = Date.now();
    var ifr = document.createElement("iframe");
    ifr.src = url; //这里是唤起App的协议，有Android可爱的同事提供
    ifr.style.display = "none";
    document.body.appendChild(ifr);
    setTimeout(function() {
      var endTime = Date.now();
      if (!startTime || endTime - startTime < timeout + 300) {
        document.body.removeChild(ifr);
        window.open(
          "http://kingofdinner.realsun.me:9093/pwapp/app-realease.apk"
        );
      }
    }, timeout);
  }
  document.addEventListener(
    "visibilitychange",
    function() {
      window.isBlur = document.hidden;
      // Modify behavior...
    },
    false
  );
  window.onblur = function() {
    isBlur = true;
  };
}

class SharePage extends React.Component {
  componentDidMount() {
    document.title = "打开应用";
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      /* 这是微信浏览器 */
    } else {
      /* 不是微信浏览器 */
      // openApp();
      const search = document.location.search;
      const querystring = search.substring(1);
      const { url } = qs.parse(querystring);
      _openApp(url, () => {
        if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
          window.location.href =
            "https://apps.apple.com/cn/app/%E8%8F%B2%E5%B0%BC%E8%90%A8%E6%B1%82%E8%81%8C%E9%80%9A/id1500104460"; //Ios下载地址
        } else if (navigator.userAgent.match(/android/i)) {
          window.open(
            "http://kingofdinner.realsun.me:9093/pwapp/app-release.apk"
          );
        }
      });
    }
  }
  render() {
    return (
      IS_WX && (
        <div
          style={{ background: "#000000", height: "100%" }}
          className="android-mask"
        >
          <div style={{ display: "flex" }}>
            <p
              style={{
                color: "#ffffff",
                flex: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 18,
                textShadow: "0px 0px 15px rgba(0, 0, 0, 0.33)",
              }}
            >
              请您点击右上角在浏览器中查看
            </p>
            <img
              src={pointPNG}
              style={{ height: "60px", width: "auto", marginRight: 8 }}
            />
          </div>
        </div>
      )
    );
  }
}

export default SharePage;
